import type { Config } from '@carla/flora'

export const constants = {
  HEADER_HEIGHT: 72,
  zIndex: {
    COOKIE_CONSENT: 17,
    ROUTE_CHANGE_LOADING: 16,
    MODAL_LEVEL3: 15,
    MODAL_LEVEL2: 14,
    MODAL_LEVEL1: 13,
    // MODAL default is 10
    HAMBURGER_MENU: 9,
    CHECKOUT_MENU: 8,
    ONLINE_CHAT_WIDGET: 7,
    HEADER: 7,
    PLP_HEADER: 6,
    HERO_SECTION: 5,
    PRODUCT_LABEL: 5,
    GALLERY_ARROWS: 5,
    THREESIXTY_GALLERY_BUTTON: 5,
    FOOTER: 5,
  },
}

export const config = {
  constants,
  status: {
    trustPilot: 'ready',
  },
  linkComponent: ({ children, href, ...linkProps }: { children: React.ReactNode; href: string }) => {
    if (!href) {
      return <span {...linkProps}>{children}</span>
    }

    return (
      <a href={href} {...linkProps}>
        {children}
      </a>
    )
  },
} as Config
